var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.SlideOutUp = exports.SlideOutRight = exports.SlideOutLeft = exports.SlideOutDown = exports.SlideInUp = exports.SlideInRight = exports.SlideInLeft = exports.SlideInDown = void 0;
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _animationBuilder = require("../animationBuilder");
function _createSuper(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = (0, _getPrototypeOf2.default)(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = (0, _getPrototypeOf2.default)(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else {
            result = Super.apply(this, arguments);
        }
        return (0, _possibleConstructorReturn2.default)(this, result);
    };
}
function _isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
var _worklet_1354766882731_init_data = {
    code: "function anonymous(values){const{delayFunction,delay,animation,config,initialValues,callback}=this.__closure;return{animations:{originX:delayFunction(delay,animation(values.targetOriginX,config))},initialValues:{originX:values.targetOriginX+values.windowWidth,...initialValues},callback:callback};}",
    location: "/vercel/path0/example/node_modules/react-native-reanimated/src/reanimated2/layoutReanimation/defaultAnimations/Slide.ts",
    sourceMap: '{"version":3,"names":["anonymous","values","delayFunction","delay","animation","config","initialValues","callback","__closure","animations","originX","targetOriginX","windowWidth"],"sources":["/vercel/path0/example/node_modules/react-native-reanimated/src/reanimated2/layoutReanimation/defaultAnimations/Slide.ts"],"mappings":"AA2BY,SAAAA,SAAMA,CAAKC,MAAA,QAAAC,aAAA,CAAAC,KAAA,CAAAC,SAAA,CAAAC,MAAA,CAAAC,aAAA,CAAAC,QAAA,OAAAC,SAAA,CAEjB,MAAO,CACLC,UAAU,CAAE,CACVC,OAAO,CAAER,aAAa,CACpBC,KAAK,CACLC,SAAS,CAACH,MAAM,CAACU,aAAa,CAAEN,MAAM,CACxC,CACF,CAAC,CACDC,aAAa,CAAE,CACbI,OAAO,CAAET,MAAM,CAACU,aAAa,CAAGV,MAAM,CAACW,WAAW,CAClD,GAAGN,aACL,CAAC,CACDC,QAAQ,CAAEA,QACZ,CAAC,CACH"}',
    version: "3.5.4"
};
var SlideInRight = exports.SlideInRight = function(_ComplexAnimationBuil) {
    (0, _inherits2.default)(SlideInRight, _ComplexAnimationBuil);
    var _super = _createSuper(SlideInRight);
    function SlideInRight() {
        var _this;
        (0, _classCallCheck2.default)(this, SlideInRight);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        _this.build = function() {
            var delayFunction = _this.getDelayFunction();
            var _this$getAnimationAnd = _this.getAnimationAndConfig(), _this$getAnimationAnd2 = (0, _slicedToArray2.default)(_this$getAnimationAnd, 2), animation = _this$getAnimationAnd2[0], config = _this$getAnimationAnd2[1];
            var delay = _this.getDelay();
            var callback = _this.callbackV;
            var initialValues = _this.initialValues;
            return function() {
                var _e = [
                    new global.Error(),
                    -7,
                    -27
                ];
                var anonymous = function anonymous(values) {
                    return {
                        animations: {
                            originX: delayFunction(delay, animation(values.targetOriginX, config))
                        },
                        initialValues: Object.assign({
                            originX: values.targetOriginX + values.windowWidth
                        }, initialValues),
                        callback: callback
                    };
                };
                anonymous.__closure = {
                    delayFunction: delayFunction,
                    delay: delay,
                    animation: animation,
                    config: config,
                    initialValues: initialValues,
                    callback: callback
                };
                anonymous.__initData = _worklet_1354766882731_init_data;
                anonymous.__workletHash = 1354766882731;
                anonymous.__stackDetails = _e;
                return anonymous;
            }();
        };
        return _this;
    }
    (0, _createClass2.default)(SlideInRight, null, [
        {
            key: "createInstance",
            value: function createInstance() {
                return new SlideInRight();
            }
        }
    ]);
    return SlideInRight;
}(_animationBuilder.ComplexAnimationBuilder);
var _worklet_12824868876973_init_data = {
    code: "function anonymous(values){const{delayFunction,delay,animation,config,initialValues,callback}=this.__closure;return{animations:{originX:delayFunction(delay,animation(values.targetOriginX,config))},initialValues:{originX:values.targetOriginX-values.windowWidth,...initialValues},callback:callback};}",
    location: "/vercel/path0/example/node_modules/react-native-reanimated/src/reanimated2/layoutReanimation/defaultAnimations/Slide.ts",
    sourceMap: '{"version":3,"names":["anonymous","values","delayFunction","delay","animation","config","initialValues","callback","__closure","animations","originX","targetOriginX","windowWidth"],"sources":["/vercel/path0/example/node_modules/react-native-reanimated/src/reanimated2/layoutReanimation/defaultAnimations/Slide.ts"],"mappings":"AA+DY,SAAAA,SAAMA,CAAKC,MAAA,QAAAC,aAAA,CAAAC,KAAA,CAAAC,SAAA,CAAAC,MAAA,CAAAC,aAAA,CAAAC,QAAA,OAAAC,SAAA,CAEjB,MAAO,CACLC,UAAU,CAAE,CACVC,OAAO,CAAER,aAAa,CACpBC,KAAK,CACLC,SAAS,CAACH,MAAM,CAACU,aAAa,CAAEN,MAAM,CACxC,CACF,CAAC,CACDC,aAAa,CAAE,CACbI,OAAO,CAAET,MAAM,CAACU,aAAa,CAAGV,MAAM,CAACW,WAAW,CAClD,GAAGN,aACL,CAAC,CACDC,QAAQ,CAAEA,QACZ,CAAC,CACH"}',
    version: "3.5.4"
};
var SlideInLeft = exports.SlideInLeft = function(_ComplexAnimationBuil2) {
    (0, _inherits2.default)(SlideInLeft, _ComplexAnimationBuil2);
    var _super2 = _createSuper(SlideInLeft);
    function SlideInLeft() {
        var _this2;
        (0, _classCallCheck2.default)(this, SlideInLeft);
        for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++){
            args[_key2] = arguments[_key2];
        }
        _this2 = _super2.call.apply(_super2, [
            this
        ].concat(args));
        _this2.build = function() {
            var delayFunction = _this2.getDelayFunction();
            var _this2$getAnimationAn = _this2.getAnimationAndConfig(), _this2$getAnimationAn2 = (0, _slicedToArray2.default)(_this2$getAnimationAn, 2), animation = _this2$getAnimationAn2[0], config = _this2$getAnimationAn2[1];
            var delay = _this2.getDelay();
            var callback = _this2.callbackV;
            var initialValues = _this2.initialValues;
            return function() {
                var _e = [
                    new global.Error(),
                    -7,
                    -27
                ];
                var anonymous = function anonymous(values) {
                    return {
                        animations: {
                            originX: delayFunction(delay, animation(values.targetOriginX, config))
                        },
                        initialValues: Object.assign({
                            originX: values.targetOriginX - values.windowWidth
                        }, initialValues),
                        callback: callback
                    };
                };
                anonymous.__closure = {
                    delayFunction: delayFunction,
                    delay: delay,
                    animation: animation,
                    config: config,
                    initialValues: initialValues,
                    callback: callback
                };
                anonymous.__initData = _worklet_12824868876973_init_data;
                anonymous.__workletHash = 12824868876973;
                anonymous.__stackDetails = _e;
                return anonymous;
            }();
        };
        return _this2;
    }
    (0, _createClass2.default)(SlideInLeft, null, [
        {
            key: "createInstance",
            value: function createInstance() {
                return new SlideInLeft();
            }
        }
    ]);
    return SlideInLeft;
}(_animationBuilder.ComplexAnimationBuilder);
var _worklet_11945388999920_init_data = {
    code: "function anonymous(values){const{delayFunction,delay,animation,config,initialValues,callback}=this.__closure;return{animations:{originX:delayFunction(delay,animation(Math.max(values.currentOriginX+values.windowWidth,values.windowWidth),config))},initialValues:{originX:values.currentOriginX,...initialValues},callback:callback};}",
    location: "/vercel/path0/example/node_modules/react-native-reanimated/src/reanimated2/layoutReanimation/defaultAnimations/Slide.ts",
    sourceMap: '{"version":3,"names":["anonymous","values","delayFunction","delay","animation","config","initialValues","callback","__closure","animations","originX","Math","max","currentOriginX","windowWidth"],"sources":["/vercel/path0/example/node_modules/react-native-reanimated/src/reanimated2/layoutReanimation/defaultAnimations/Slide.ts"],"mappings":"AAmGY,SAAAA,SAAMA,CAAKC,MAAA,QAAAC,aAAA,CAAAC,KAAA,CAAAC,SAAA,CAAAC,MAAA,CAAAC,aAAA,CAAAC,QAAA,OAAAC,SAAA,CAEjB,MAAO,CACLC,UAAU,CAAE,CACVC,OAAO,CAAER,aAAa,CACpBC,KAAK,CACLC,SAAS,CACPO,IAAI,CAACC,GAAG,CACNX,MAAM,CAACY,cAAc,CAAGZ,MAAM,CAACa,WAAW,CAC1Cb,MAAM,CAACa,WACT,CAAC,CACDT,MACF,CACF,CACF,CAAC,CACDC,aAAa,CAAE,CACbI,OAAO,CAAET,MAAM,CAACY,cAAc,CAC9B,GAAGP,aACL,CAAC,CACDC,QAAQ,CAAEA,QACZ,CAAC,CACH"}',
    version: "3.5.4"
};
var SlideOutRight = exports.SlideOutRight = function(_ComplexAnimationBuil3) {
    (0, _inherits2.default)(SlideOutRight, _ComplexAnimationBuil3);
    var _super3 = _createSuper(SlideOutRight);
    function SlideOutRight() {
        var _this3;
        (0, _classCallCheck2.default)(this, SlideOutRight);
        for(var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++){
            args[_key3] = arguments[_key3];
        }
        _this3 = _super3.call.apply(_super3, [
            this
        ].concat(args));
        _this3.build = function() {
            var delayFunction = _this3.getDelayFunction();
            var _this3$getAnimationAn = _this3.getAnimationAndConfig(), _this3$getAnimationAn2 = (0, _slicedToArray2.default)(_this3$getAnimationAn, 2), animation = _this3$getAnimationAn2[0], config = _this3$getAnimationAn2[1];
            var delay = _this3.getDelay();
            var callback = _this3.callbackV;
            var initialValues = _this3.initialValues;
            return function() {
                var _e = [
                    new global.Error(),
                    -7,
                    -27
                ];
                var anonymous = function anonymous(values) {
                    return {
                        animations: {
                            originX: delayFunction(delay, animation(Math.max(values.currentOriginX + values.windowWidth, values.windowWidth), config))
                        },
                        initialValues: Object.assign({
                            originX: values.currentOriginX
                        }, initialValues),
                        callback: callback
                    };
                };
                anonymous.__closure = {
                    delayFunction: delayFunction,
                    delay: delay,
                    animation: animation,
                    config: config,
                    initialValues: initialValues,
                    callback: callback
                };
                anonymous.__initData = _worklet_11945388999920_init_data;
                anonymous.__workletHash = 11945388999920;
                anonymous.__stackDetails = _e;
                return anonymous;
            }();
        };
        return _this3;
    }
    (0, _createClass2.default)(SlideOutRight, null, [
        {
            key: "createInstance",
            value: function createInstance() {
                return new SlideOutRight();
            }
        }
    ]);
    return SlideOutRight;
}(_animationBuilder.ComplexAnimationBuilder);
var _worklet_10070003644773_init_data = {
    code: "function anonymous(values){const{delayFunction,delay,animation,config,initialValues,callback}=this.__closure;return{animations:{originX:delayFunction(delay,animation(Math.min(values.currentOriginX-values.windowWidth,-values.windowWidth),config))},initialValues:{originX:values.currentOriginX,...initialValues},callback:callback};}",
    location: "/vercel/path0/example/node_modules/react-native-reanimated/src/reanimated2/layoutReanimation/defaultAnimations/Slide.ts",
    sourceMap: '{"version":3,"names":["anonymous","values","delayFunction","delay","animation","config","initialValues","callback","__closure","animations","originX","Math","min","currentOriginX","windowWidth"],"sources":["/vercel/path0/example/node_modules/react-native-reanimated/src/reanimated2/layoutReanimation/defaultAnimations/Slide.ts"],"mappings":"AA6IY,SAAAA,SAAMA,CAAKC,MAAA,QAAAC,aAAA,CAAAC,KAAA,CAAAC,SAAA,CAAAC,MAAA,CAAAC,aAAA,CAAAC,QAAA,OAAAC,SAAA,CAEjB,MAAO,CACLC,UAAU,CAAE,CACVC,OAAO,CAAER,aAAa,CACpBC,KAAK,CACLC,SAAS,CACPO,IAAI,CAACC,GAAG,CACNX,MAAM,CAACY,cAAc,CAAGZ,MAAM,CAACa,WAAW,CAC1C,CAACb,MAAM,CAACa,WACV,CAAC,CACDT,MACF,CACF,CACF,CAAC,CACDC,aAAa,CAAE,CACbI,OAAO,CAAET,MAAM,CAACY,cAAc,CAC9B,GAAGP,aACL,CAAC,CACDC,QAAQ,CAAEA,QACZ,CAAC,CACH"}',
    version: "3.5.4"
};
var SlideOutLeft = exports.SlideOutLeft = function(_ComplexAnimationBuil4) {
    (0, _inherits2.default)(SlideOutLeft, _ComplexAnimationBuil4);
    var _super4 = _createSuper(SlideOutLeft);
    function SlideOutLeft() {
        var _this4;
        (0, _classCallCheck2.default)(this, SlideOutLeft);
        for(var _len4 = arguments.length, args = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++){
            args[_key4] = arguments[_key4];
        }
        _this4 = _super4.call.apply(_super4, [
            this
        ].concat(args));
        _this4.build = function() {
            var delayFunction = _this4.getDelayFunction();
            var _this4$getAnimationAn = _this4.getAnimationAndConfig(), _this4$getAnimationAn2 = (0, _slicedToArray2.default)(_this4$getAnimationAn, 2), animation = _this4$getAnimationAn2[0], config = _this4$getAnimationAn2[1];
            var delay = _this4.getDelay();
            var callback = _this4.callbackV;
            var initialValues = _this4.initialValues;
            return function() {
                var _e = [
                    new global.Error(),
                    -7,
                    -27
                ];
                var anonymous = function anonymous(values) {
                    return {
                        animations: {
                            originX: delayFunction(delay, animation(Math.min(values.currentOriginX - values.windowWidth, -values.windowWidth), config))
                        },
                        initialValues: Object.assign({
                            originX: values.currentOriginX
                        }, initialValues),
                        callback: callback
                    };
                };
                anonymous.__closure = {
                    delayFunction: delayFunction,
                    delay: delay,
                    animation: animation,
                    config: config,
                    initialValues: initialValues,
                    callback: callback
                };
                anonymous.__initData = _worklet_10070003644773_init_data;
                anonymous.__workletHash = 10070003644773;
                anonymous.__stackDetails = _e;
                return anonymous;
            }();
        };
        return _this4;
    }
    (0, _createClass2.default)(SlideOutLeft, null, [
        {
            key: "createInstance",
            value: function createInstance() {
                return new SlideOutLeft();
            }
        }
    ]);
    return SlideOutLeft;
}(_animationBuilder.ComplexAnimationBuilder);
var _worklet_10335411259806_init_data = {
    code: "function anonymous(values){const{delayFunction,delay,animation,config,initialValues,callback}=this.__closure;return{animations:{originY:delayFunction(delay,animation(values.targetOriginY,config))},initialValues:{originY:-values.windowHeight,...initialValues},callback:callback};}",
    location: "/vercel/path0/example/node_modules/react-native-reanimated/src/reanimated2/layoutReanimation/defaultAnimations/Slide.ts",
    sourceMap: '{"version":3,"names":["anonymous","values","delayFunction","delay","animation","config","initialValues","callback","__closure","animations","originY","targetOriginY","windowHeight"],"sources":["/vercel/path0/example/node_modules/react-native-reanimated/src/reanimated2/layoutReanimation/defaultAnimations/Slide.ts"],"mappings":"AAuLY,SAAAA,SAAMA,CAAKC,MAAA,QAAAC,aAAA,CAAAC,KAAA,CAAAC,SAAA,CAAAC,MAAA,CAAAC,aAAA,CAAAC,QAAA,OAAAC,SAAA,CAEjB,MAAO,CACLC,UAAU,CAAE,CACVC,OAAO,CAAER,aAAa,CACpBC,KAAK,CACLC,SAAS,CAACH,MAAM,CAACU,aAAa,CAAEN,MAAM,CACxC,CACF,CAAC,CACDC,aAAa,CAAE,CACbI,OAAO,CAAE,CAACT,MAAM,CAACW,YAAY,CAC7B,GAAGN,aACL,CAAC,CACDC,QAAQ,CAAEA,QACZ,CAAC,CACH"}',
    version: "3.5.4"
};
var SlideInUp = exports.SlideInUp = function(_ComplexAnimationBuil5) {
    (0, _inherits2.default)(SlideInUp, _ComplexAnimationBuil5);
    var _super5 = _createSuper(SlideInUp);
    function SlideInUp() {
        var _this5;
        (0, _classCallCheck2.default)(this, SlideInUp);
        for(var _len5 = arguments.length, args = new Array(_len5), _key5 = 0; _key5 < _len5; _key5++){
            args[_key5] = arguments[_key5];
        }
        _this5 = _super5.call.apply(_super5, [
            this
        ].concat(args));
        _this5.build = function() {
            var delayFunction = _this5.getDelayFunction();
            var _this5$getAnimationAn = _this5.getAnimationAndConfig(), _this5$getAnimationAn2 = (0, _slicedToArray2.default)(_this5$getAnimationAn, 2), animation = _this5$getAnimationAn2[0], config = _this5$getAnimationAn2[1];
            var delay = _this5.getDelay();
            var callback = _this5.callbackV;
            var initialValues = _this5.initialValues;
            return function() {
                var _e = [
                    new global.Error(),
                    -7,
                    -27
                ];
                var anonymous = function anonymous(values) {
                    return {
                        animations: {
                            originY: delayFunction(delay, animation(values.targetOriginY, config))
                        },
                        initialValues: Object.assign({
                            originY: -values.windowHeight
                        }, initialValues),
                        callback: callback
                    };
                };
                anonymous.__closure = {
                    delayFunction: delayFunction,
                    delay: delay,
                    animation: animation,
                    config: config,
                    initialValues: initialValues,
                    callback: callback
                };
                anonymous.__initData = _worklet_10335411259806_init_data;
                anonymous.__workletHash = 10335411259806;
                anonymous.__stackDetails = _e;
                return anonymous;
            }();
        };
        return _this5;
    }
    (0, _createClass2.default)(SlideInUp, null, [
        {
            key: "createInstance",
            value: function createInstance() {
                return new SlideInUp();
            }
        }
    ]);
    return SlideInUp;
}(_animationBuilder.ComplexAnimationBuilder);
var _worklet_2944727101906_init_data = {
    code: "function anonymous(values){const{delayFunction,delay,animation,config,initialValues,callback}=this.__closure;return{animations:{originY:delayFunction(delay,animation(values.targetOriginY,config))},initialValues:{originY:values.targetOriginY+values.windowHeight,...initialValues},callback:callback};}",
    location: "/vercel/path0/example/node_modules/react-native-reanimated/src/reanimated2/layoutReanimation/defaultAnimations/Slide.ts",
    sourceMap: '{"version":3,"names":["anonymous","values","delayFunction","delay","animation","config","initialValues","callback","__closure","animations","originY","targetOriginY","windowHeight"],"sources":["/vercel/path0/example/node_modules/react-native-reanimated/src/reanimated2/layoutReanimation/defaultAnimations/Slide.ts"],"mappings":"AA2NY,SAAAA,SAAMA,CAAKC,MAAA,QAAAC,aAAA,CAAAC,KAAA,CAAAC,SAAA,CAAAC,MAAA,CAAAC,aAAA,CAAAC,QAAA,OAAAC,SAAA,CAEjB,MAAO,CACLC,UAAU,CAAE,CACVC,OAAO,CAAER,aAAa,CACpBC,KAAK,CACLC,SAAS,CAACH,MAAM,CAACU,aAAa,CAAEN,MAAM,CACxC,CACF,CAAC,CACDC,aAAa,CAAE,CACbI,OAAO,CAAET,MAAM,CAACU,aAAa,CAAGV,MAAM,CAACW,YAAY,CACnD,GAAGN,aACL,CAAC,CACDC,QAAQ,CAAEA,QACZ,CAAC,CACH"}',
    version: "3.5.4"
};
var SlideInDown = exports.SlideInDown = function(_ComplexAnimationBuil6) {
    (0, _inherits2.default)(SlideInDown, _ComplexAnimationBuil6);
    var _super6 = _createSuper(SlideInDown);
    function SlideInDown() {
        var _this6;
        (0, _classCallCheck2.default)(this, SlideInDown);
        for(var _len6 = arguments.length, args = new Array(_len6), _key6 = 0; _key6 < _len6; _key6++){
            args[_key6] = arguments[_key6];
        }
        _this6 = _super6.call.apply(_super6, [
            this
        ].concat(args));
        _this6.build = function() {
            var delayFunction = _this6.getDelayFunction();
            var _this6$getAnimationAn = _this6.getAnimationAndConfig(), _this6$getAnimationAn2 = (0, _slicedToArray2.default)(_this6$getAnimationAn, 2), animation = _this6$getAnimationAn2[0], config = _this6$getAnimationAn2[1];
            var delay = _this6.getDelay();
            var callback = _this6.callbackV;
            var initialValues = _this6.initialValues;
            return function() {
                var _e = [
                    new global.Error(),
                    -7,
                    -27
                ];
                var anonymous = function anonymous(values) {
                    return {
                        animations: {
                            originY: delayFunction(delay, animation(values.targetOriginY, config))
                        },
                        initialValues: Object.assign({
                            originY: values.targetOriginY + values.windowHeight
                        }, initialValues),
                        callback: callback
                    };
                };
                anonymous.__closure = {
                    delayFunction: delayFunction,
                    delay: delay,
                    animation: animation,
                    config: config,
                    initialValues: initialValues,
                    callback: callback
                };
                anonymous.__initData = _worklet_2944727101906_init_data;
                anonymous.__workletHash = 2944727101906;
                anonymous.__stackDetails = _e;
                return anonymous;
            }();
        };
        return _this6;
    }
    (0, _createClass2.default)(SlideInDown, null, [
        {
            key: "createInstance",
            value: function createInstance() {
                return new SlideInDown();
            }
        }
    ]);
    return SlideInDown;
}(_animationBuilder.ComplexAnimationBuilder);
var _worklet_9782261456133_init_data = {
    code: "function anonymous(values){const{delayFunction,delay,animation,config,initialValues,callback}=this.__closure;return{animations:{originY:delayFunction(delay,animation(Math.min(values.currentOriginY-values.windowHeight,-values.windowHeight),config))},initialValues:{originY:values.currentOriginY,...initialValues},callback:callback};}",
    location: "/vercel/path0/example/node_modules/react-native-reanimated/src/reanimated2/layoutReanimation/defaultAnimations/Slide.ts",
    sourceMap: '{"version":3,"names":["anonymous","values","delayFunction","delay","animation","config","initialValues","callback","__closure","animations","originY","Math","min","currentOriginY","windowHeight"],"sources":["/vercel/path0/example/node_modules/react-native-reanimated/src/reanimated2/layoutReanimation/defaultAnimations/Slide.ts"],"mappings":"AA+PY,SAAAA,SAAMA,CAAKC,MAAA,QAAAC,aAAA,CAAAC,KAAA,CAAAC,SAAA,CAAAC,MAAA,CAAAC,aAAA,CAAAC,QAAA,OAAAC,SAAA,CAEjB,MAAO,CACLC,UAAU,CAAE,CACVC,OAAO,CAAER,aAAa,CACpBC,KAAK,CACLC,SAAS,CACPO,IAAI,CAACC,GAAG,CACNX,MAAM,CAACY,cAAc,CAAGZ,MAAM,CAACa,YAAY,CAC3C,CAACb,MAAM,CAACa,YACV,CAAC,CACDT,MACF,CACF,CACF,CAAC,CACDC,aAAa,CAAE,CAAEI,OAAO,CAAET,MAAM,CAACY,cAAc,CAAE,GAAGP,aAAc,CAAC,CACnEC,QAAQ,CAAEA,QACZ,CAAC,CACH"}',
    version: "3.5.4"
};
var SlideOutUp = exports.SlideOutUp = function(_ComplexAnimationBuil7) {
    (0, _inherits2.default)(SlideOutUp, _ComplexAnimationBuil7);
    var _super7 = _createSuper(SlideOutUp);
    function SlideOutUp() {
        var _this7;
        (0, _classCallCheck2.default)(this, SlideOutUp);
        for(var _len7 = arguments.length, args = new Array(_len7), _key7 = 0; _key7 < _len7; _key7++){
            args[_key7] = arguments[_key7];
        }
        _this7 = _super7.call.apply(_super7, [
            this
        ].concat(args));
        _this7.build = function() {
            var delayFunction = _this7.getDelayFunction();
            var _this7$getAnimationAn = _this7.getAnimationAndConfig(), _this7$getAnimationAn2 = (0, _slicedToArray2.default)(_this7$getAnimationAn, 2), animation = _this7$getAnimationAn2[0], config = _this7$getAnimationAn2[1];
            var delay = _this7.getDelay();
            var callback = _this7.callbackV;
            var initialValues = _this7.initialValues;
            return function() {
                var _e = [
                    new global.Error(),
                    -7,
                    -27
                ];
                var anonymous = function anonymous(values) {
                    return {
                        animations: {
                            originY: delayFunction(delay, animation(Math.min(values.currentOriginY - values.windowHeight, -values.windowHeight), config))
                        },
                        initialValues: Object.assign({
                            originY: values.currentOriginY
                        }, initialValues),
                        callback: callback
                    };
                };
                anonymous.__closure = {
                    delayFunction: delayFunction,
                    delay: delay,
                    animation: animation,
                    config: config,
                    initialValues: initialValues,
                    callback: callback
                };
                anonymous.__initData = _worklet_9782261456133_init_data;
                anonymous.__workletHash = 9782261456133;
                anonymous.__stackDetails = _e;
                return anonymous;
            }();
        };
        return _this7;
    }
    (0, _createClass2.default)(SlideOutUp, null, [
        {
            key: "createInstance",
            value: function createInstance() {
                return new SlideOutUp();
            }
        }
    ]);
    return SlideOutUp;
}(_animationBuilder.ComplexAnimationBuilder);
var _worklet_430860199888_init_data = {
    code: "function anonymous(values){const{delayFunction,delay,animation,config,initialValues,callback}=this.__closure;return{animations:{originY:delayFunction(delay,animation(Math.max(values.currentOriginY+values.windowHeight,values.windowHeight),config))},initialValues:{originY:values.currentOriginY,...initialValues},callback:callback};}",
    location: "/vercel/path0/example/node_modules/react-native-reanimated/src/reanimated2/layoutReanimation/defaultAnimations/Slide.ts",
    sourceMap: '{"version":3,"names":["anonymous","values","delayFunction","delay","animation","config","initialValues","callback","__closure","animations","originY","Math","max","currentOriginY","windowHeight"],"sources":["/vercel/path0/example/node_modules/react-native-reanimated/src/reanimated2/layoutReanimation/defaultAnimations/Slide.ts"],"mappings":"AAsSY,SAAAA,SAAMA,CAAKC,MAAA,QAAAC,aAAA,CAAAC,KAAA,CAAAC,SAAA,CAAAC,MAAA,CAAAC,aAAA,CAAAC,QAAA,OAAAC,SAAA,CAEjB,MAAO,CACLC,UAAU,CAAE,CACVC,OAAO,CAAER,aAAa,CACpBC,KAAK,CACLC,SAAS,CACPO,IAAI,CAACC,GAAG,CACNX,MAAM,CAACY,cAAc,CAAGZ,MAAM,CAACa,YAAY,CAC3Cb,MAAM,CAACa,YACT,CAAC,CACDT,MACF,CACF,CACF,CAAC,CACDC,aAAa,CAAE,CAAEI,OAAO,CAAET,MAAM,CAACY,cAAc,CAAE,GAAGP,aAAc,CAAC,CACnEC,QAAQ,CAAEA,QACZ,CAAC,CACH"}',
    version: "3.5.4"
};
var SlideOutDown = exports.SlideOutDown = function(_ComplexAnimationBuil8) {
    (0, _inherits2.default)(SlideOutDown, _ComplexAnimationBuil8);
    var _super8 = _createSuper(SlideOutDown);
    function SlideOutDown() {
        var _this8;
        (0, _classCallCheck2.default)(this, SlideOutDown);
        for(var _len8 = arguments.length, args = new Array(_len8), _key8 = 0; _key8 < _len8; _key8++){
            args[_key8] = arguments[_key8];
        }
        _this8 = _super8.call.apply(_super8, [
            this
        ].concat(args));
        _this8.build = function() {
            var delayFunction = _this8.getDelayFunction();
            var _this8$getAnimationAn = _this8.getAnimationAndConfig(), _this8$getAnimationAn2 = (0, _slicedToArray2.default)(_this8$getAnimationAn, 2), animation = _this8$getAnimationAn2[0], config = _this8$getAnimationAn2[1];
            var delay = _this8.getDelay();
            var callback = _this8.callbackV;
            var initialValues = _this8.initialValues;
            return function() {
                var _e = [
                    new global.Error(),
                    -7,
                    -27
                ];
                var anonymous = function anonymous(values) {
                    return {
                        animations: {
                            originY: delayFunction(delay, animation(Math.max(values.currentOriginY + values.windowHeight, values.windowHeight), config))
                        },
                        initialValues: Object.assign({
                            originY: values.currentOriginY
                        }, initialValues),
                        callback: callback
                    };
                };
                anonymous.__closure = {
                    delayFunction: delayFunction,
                    delay: delay,
                    animation: animation,
                    config: config,
                    initialValues: initialValues,
                    callback: callback
                };
                anonymous.__initData = _worklet_430860199888_init_data;
                anonymous.__workletHash = 430860199888;
                anonymous.__stackDetails = _e;
                return anonymous;
            }();
        };
        return _this8;
    }
    (0, _createClass2.default)(SlideOutDown, null, [
        {
            key: "createInstance",
            value: function createInstance() {
                return new SlideOutDown();
            }
        }
    ]);
    return SlideOutDown;
}(_animationBuilder.ComplexAnimationBuilder);
